/**
 * rubyText.tsx
 * ルビ（ふりがな）付きテキストを表示するコンポーネント
 * 教育向けに漢字にふりがなを表示するために使用
 */
import React from 'react';
import type { RubyPart } from './types';

/**
 * ルビテキスト表示コンポーネント
 *
 * RubyPart配列を受け取り、HTMLの<ruby>タグを使って
 * ふりがな付きテキストをレンダリングする
 *
 * @example
 * const parts = [
 *   { kind: 'text', text: 'プログラムが' },
 *   { kind: 'ruby', base: '始', ruby: 'はじ' },
 *   { kind: 'text', text: 'まる' }
 * ];
 * <RubyText parts={parts} />
 * // → "プログラムが始(はじ)まる"
 */
export function RubyText({ parts }: { parts: RubyPart[] }) {
  return (
    <>
      {parts.map((p, i) => {
        // 通常テキストはそのまま表示
        if (p.kind === 'text') {
          return <React.Fragment key={i}>{p.text}</React.Fragment>;
        }

        // ルビ付きテキストは<ruby>タグで表示
        // <rp>はルビ非対応ブラウザ用のフォールバック（括弧表示）
        return (
          <ruby key={i}>
            {p.base}
            <rp>(</rp>
            <rt>{p.ruby}</rt>
            <rp>)</rp>
          </ruby>
        );
      })}
    </>
  );
}

